<template>
  <SharedCommon />
</template>

<script setup lang="ts">
import SharedCommon from "@/.shared/components/SharedCommon.vue";
import { useIntl } from "@services/i18n/i18nservice";
import { onBeforeMount } from "vue";

const intl = useIntl();

onBeforeMount(async () => {
  await intl.setLocale(intl.guessDefaultLocale());
});
</script>
